import { useRoutes } from 'react-router-dom';

import { useAuth } from '@/providers/auth';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const { user } = useAuth();
  const userRoutes = user && !user.imperfect ? protectedRoutes : publicRoutes;

  const element = useRoutes(userRoutes);

  return <>{element}</>;
};
